<template>
  <div
    class="tag tooltip"
    v-bind:class="getStatus(item)"
    v-bind:data-tooltip="item.marker_name"
  >
    <strong>{{ item.marker_code }}</strong>
  </div>
</template>
<script>
import { getRecordMarkerStatus } from "@/functions/getRecordMarkerStatus";

export default {
  name: "item-status",
  props: {
    item: {}
  },
  methods: {
    getStatus: function(item) {
      return getRecordMarkerStatus(item);
    }
  }
};
</script>
